import React, { useEffect, useState } from "react";
import CalendarSVG from "../assets/precheckin/calendar.svg";
import {
  WheelDiv,
  customCalendarClassNames,
  WrapperStyles,
} from "./styles/HourlyProductStyle";
import { Modal } from "react-responsive-modal";
import WheelPicker from "react-simple-wheel-picker";
import moment from "moment";

const HourlyProduct = (props) => {
  const timeframes = () => {
    return [
      { id: "anytime", value: props.t("INVENTORY_POPUP_ANYTIME", "Anytime") },
      { id: "morning", value: props.t("INVENTORY_POPUP_MORNING","Morning") },
      { id: "afternoon", value: props.t("INVENTORY_POPUP_AFTERNOON","Afternoon") },
      { id: "evening", value: props.t("INVENTORY_POPUP_EVENING","Evening") },
    ];
  };
  const [hourlyProductOpen, setHourlyProductOpen] = useState(false);
  const [date, setDate] = useState(
    props.getDate || moment().format("YYYYMMDD")
  );
  const [timeframe, setTimeframe] = useState(
    props.getTimeframe || timeframes()[0].id
  );
  const from = props.fromDate || moment().format("YYYY-MM-DD");
  const to = props.toDate || moment().format("YYYY-MM-DD");

  const onCloseHourlyProductModal = () => {
    props.onCancel();
    const html = document.querySelector("html");
    html.style = "";
  };
  const handleRangeOfDate = (target) => setDate(target.id);
  const handleRangeOfTimeframe = (target) => setTimeframe(target.id);

  const rangeOfDates = () => {
    let range = [];
    if (props.dates && props.dates.length > 0) {
      props.dates.map((date) =>
        range.push({
          id: date.format("YYYYMMDD"),
          value: date.format(`ddd, MMM DD`),
        })
      );
    } else {
      const fromDate = moment(from);
      const toDate = moment(to);
      let diff = toDate.diff(fromDate, "days");
      diff = diff ? diff : 0;
      for (let i = 0; i <= diff; i++) {
        let fromDateClone = fromDate.clone();
        fromDateClone = fromDateClone.add(i, "day");
        let weekFormat = "ddd";
        let preWeekFormat = "";
        if (i === 0) {
          weekFormat = "";
          preWeekFormat = "Today";
        } else if (i === 1) {
          weekFormat = "";
          preWeekFormat = "Tomorrow";
        }
        range.push({
          id: fromDateClone.format("YYYYMMDD"),
          value: `${preWeekFormat}${fromDateClone.format(
            `${weekFormat}, MMM DD`
          )}`,
        });
      }
    }
    return range;
  };

  const selectBtn = (e) => {
    onCloseHourlyProductModal();
    props.onSelect({
      date,
      timeframe,
      e,
    });
  };

  useEffect(() => {
    if (props.showPopup) {
      setHourlyProductOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.showPopup]);

  return (
    <div className="h-full">
      <Modal
        open={hourlyProductOpen}
        onClose={onCloseHourlyProductModal}
        center
        blockScroll={true}
        classNames={customCalendarClassNames}>
        <div className="relative h-full flex flex-col">
          <div style={{ backgroundColor: "#EAEAEA" }}>
            <div className="flex mx-auto max-w-xl py-4">
              <h3 className="text-14 px-4 py-3">{props.modalTitle}</h3>
            </div>
          </div>
          <div className="mb-4 flex-1">
            <WrapperStyles className="flex mx-auto max-w-xl">
              <div className="flex items-center">
                <img
                  src={CalendarSVG}
                  alt="calendar"
                  className="w-8"
                />
              </div>
              <WheelDiv
                className="flex items-center relative flex-1"
                style={{
                  marginRight: "10px",
                  paddingRight: "10px",
                }}>
                <WheelPicker
                  name="date"
                  data={rangeOfDates()}
                  onChange={handleRangeOfDate}
                  height={150}
                  titleText="Enter date"
                  itemHeight={30}
                  selectedID={date}
                  color="#ccc"
                  activeColor="#333"
                  backgroundColor="#fff"
                  shadowColor="#fff"
                  focusColor="fff"
                />
                <div className="ms-select-line"></div>
                <div className="ms-shadow-mask"></div>
              </WheelDiv>
              {!props.noTimeFrames && (
                <>
                  <div
                    className="flex items-center"
                    style={{
                      paddingLeft: "10px",
                      borderLeft: "1px solid #DBDBDB",
                    }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-8 w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <WheelDiv className="flex items-center relative flex-1">
                    <WheelPicker
                      name="timeframe"
                      data={timeframes()}
                      onChange={handleRangeOfTimeframe}
                      height={150}
                      titleText="Enter timeframe"
                      itemHeight={30}
                      selectedID={timeframe}
                      color="#ccc"
                      activeColor="#333"
                      backgroundColor="#fff"
                      shadowColor="#fff"
                    />
                    <div className="ms-select-line"></div>
                    <div className="ms-shadow-mask"></div>
                  </WheelDiv>
                </>
              )}
            </WrapperStyles>
          </div>
          <div className="md:w-48 md:mx-auto">
            <button
              className={`app-button ${props.buttonStyleName} tablet-only-style-button`}
              style={{
                backgroundColor: props.primaryColor,
                color: props.appHomeTextCallToAction || "#ffffff",
              }}
              onClick={selectBtn}>
              {props.t("SELECT")}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default HourlyProduct;
